import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from '@myosh/icons';
import { Button, ButtonGroup, ButtonGroupText } from '@myosh/odin-components';
import { useTranslation } from 'react-i18next';

interface SchedulesPaginationProps {
  page: number;
  availablePages: number;
  onPageChange: (page: number) => void;
}

export const SchedulesPagination = ({ page, availablePages, onPageChange }: SchedulesPaginationProps) => {
  const { t } = useTranslation();
  const isFirst = page <= 1;
  const isLast = page >= availablePages;

  return (
    <nav aria-label={t(($) => $.pagination)} className="flex justify-end border-t p-2">
      <ButtonGroup>
        <Button
          variant="outline"
          size="icon-sm"
          aria-label={t(($) => $.firstPage)}
          disabled={isFirst}
          onClick={() => onPageChange(1)}
        >
          <ChevronsLeft />
        </Button>
        <Button
          variant="outline"
          size="icon-sm"
          aria-label={t(($) => $.previousPage)}
          disabled={isFirst}
          onClick={() => onPageChange(page - 1)}
        >
          <ChevronLeft />
        </Button>
        <ButtonGroupText>{t(($) => $.pageOfTotal, { current: page, total: availablePages })}</ButtonGroupText>
        <Button
          variant="outline"
          size="icon-sm"
          aria-label={t(($) => $.nextPage)}
          disabled={isLast}
          onClick={() => onPageChange(page + 1)}
        >
          <ChevronRight />
        </Button>
        <Button
          variant="outline"
          size="icon-sm"
          aria-label={t(($) => $.lastPage)}
          disabled={isLast}
          onClick={() => onPageChange(availablePages)}
        >
          <ChevronsRight />
        </Button>
      </ButtonGroup>
    </nav>
  );
};
